
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/slots/providers/[id]",
      function () {
        return require("private-next-pages/slots/providers/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/slots/providers/[id]"])
      });
    }
  